import Event from '../../core/Event';
import { Filter } from '../../../domain/Filter';

export default class OrdersFilterSelected extends Event {
    public static type = 'OrdersFilterSelected';

    constructor(public readonly filter: Filter) {
        super(OrdersFilterSelected.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrdersFilterSelected.ts